const REGEX_CORREO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
// const REGEX_TELEFONO = /^(?:\+|00)[1-9]\d{1,14}$/

export const validarNombre = (nombre, msg) => {
  let error
  if (!nombre.trim()) {
    error = msg
  }

  return error
}

export const validarCorreo = (correo, msg) => {
  let error
  if (!correo.trim() || !REGEX_CORREO.test(correo)) {
    error = msg
  }

  return error
}

export const validarTelefono = (telefono, msg) => {
  let error
  if (!telefono.trim() || isNaN(telefono) /* || !REGEX_TELEFONO.test(telefono) */) {
    error = msg
  }

  return error
}
